import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import CoolCats from '../../api/contract'

import { NoWalletState } from '../../components/NoWalletState/NoWalletState'
import { WalletInfo } from './WalletInfo/WalletInfo'
import { Soldout } from './Soldout/Soldout'
import { Preloader } from '../../components/Preloader/Preloader'

import './Mint.scss'

export const Mint = () => {
	const wallet = useSelector((state) => state.wallet)
	const [nfts, setNfts] = useState({ total: 0, max: 0 })

	useEffect(() => {
		let isMount = true

		const interval = setInterval(() => {
			if (window.tronWeb && wallet.data.auth) {
				new CoolCats()
					.init(window.tronWeb)
					.then(async (contract) => {
						const total = await contract.totalSupply()
						const max = await contract.maxNftSupply()
						clearInterval(interval);

						if (isMount) setNfts({ total, max })
					})
					.catch(console.log)
			}
		}, 500);

		return () => {isMount = false; clearInterval(interval)}
	}, [wallet, setNfts])

	return (
		<div className="mint-container">
			{wallet.isLoaded ? (
				nfts.max > 0 && nfts.total === nfts.max ? (
					<Soldout />
				) : wallet.data.auth ? (
					<WalletInfo total={nfts.total} max={nfts.max} wallet={wallet.data} />
				) : (
					<NoWalletState />
				)
			) : (
				<Preloader />
			)}
		</div>
	)
}
